import { render } from "./Send.vue?vue&type=template&id=6d1eefa6"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/shop/Send.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d1eefa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d1eefa6', __exports__)) {
    api.reload('6d1eefa6', __exports__)
  }
  
  module.hot.accept("./Send.vue?vue&type=template&id=6d1eefa6", () => {
    api.rerender('6d1eefa6', render)
  })

}


export default __exports__